import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';

interface ChatWindowModalsProps {
  uploadFailedOpen: boolean;
  closeUploadFailed: () => void;
}

/** The "Upload failed" notice (the Q&A's attachments could not be read). */
const ChatWindowModals = ({
  uploadFailedOpen,
  closeUploadFailed,
}: ChatWindowModalsProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={uploadFailedOpen}
      title={t('home.chat.files.uploadFailedTitle')}
      onOk={closeUploadFailed}
      onCancel={closeUploadFailed}
      okText={t('home.chat.files.close')}
      cancelButtonProps={{ style: { display: 'none' } }}
    >
      {t('home.chat.files.uploadFailed')}
    </Modal>
  );
};

export default ChatWindowModals;
